import React from 'react'

export default function Links() {
    return (
        <div className='p-[2vw]'>
            <div className='grid grid-cols-12 gap-5 px-8 py-8 mt-5 border border-[#525252] rounded-lg'>
                <div className='md:col-span-4 col-span-full flex items-center justify-between'>
                    <h1 className='md:text-2xl text-xl text-[#FFFD0F]'>OUR <br /> PARTNERS</h1>
                    <img src="/images/arrow.png" alt="" className='md:w-[2vw] w-[5vw]' />
                </div>
                <div className='md:col-span-8 col-span-full' >
                    <div className='grid md:grid-cols-4 grid-cols-2 items-center gap-5'>
                        <a href="" className='block'>
                            <img src="/images/link-1.png" alt="" className='md:w-[12vw] w-[35vw] animate__fadeInUp wow animate__animated' />
                        </a>
                        <a href="" className='block'>
                            <img src="/images/link-2.png" alt="" className='md:w-[12vw] w-[35vw] animate__fadeInUp wow animate__animated' />
                        </a>
                        <a href="" className='block'>
                            <img src="/images/link-3.png" alt="" className='md:w-[12vw] w-[35vw] animate__fadeInUp wow animate__animated' />
                        </a>
                        <a href="" className='block'>
                            <img src="/images/link-4.png" alt="" className='md:w-[12vw] w-[35vw] animate__fadeInUp wow animate__animated' />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
